import React, { useEffect, useRef } from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

// Tona göre rozet rengi ve onay butonu stili (koyu/cam premium tema).
const TONES = {
  danger: { badge: 'bg-rose-500/15 text-rose-300 ring-rose-400/30', confirmBtn: 'btn-danger' },
  primary: { badge: 'bg-amber-400/15 text-amber-300 ring-amber-300/30', confirmBtn: 'btn-primary' },
};

/**
 * Paylaşılan premium onay diyaloğu. Doğrudan kullanılmaz; ConfirmProvider
 * tarafından monte edilir ve useConfirm() ile promise üzerinden çağrılır.
 */
const ConfirmDialog = ({
  open,
  title = 'Emin misiniz?',
  message,
  confirmText = 'Onayla',
  cancelText = 'Vazgeç',
  tone = 'danger',
  onConfirm,
  onCancel,
}) => {
  const cancelRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handleKey = (e) => {
      if (e.key === 'Escape') onCancel();
    };
    window.addEventListener('keydown', handleKey);
    // Yıkıcı eylemde güvenli varsayılan: açılışta "Vazgeç"e odaklan.
    cancelRef.current?.focus();
    return () => window.removeEventListener('keydown', handleKey);
  }, [open, onCancel]);

  if (!open) return null;

  const toneCfg = TONES[tone] || TONES.danger;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4"
      style={{ background: 'rgba(2, 6, 23, 0.6)', backdropFilter: 'blur(4px)' }}
      onClick={onCancel}
      role="presentation"
    >
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
        className="app-panel-dark w-full max-w-md animate-fade-in-up"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start gap-4">
          <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full ring-1 ${toneCfg.badge}`}>
            <ExclamationTriangleIcon className="h-6 w-6" />
          </div>
          <div className="min-w-0 flex-1">
            <h2 id="confirm-dialog-title" className="font-display text-lg font-semibold text-white">
              {title}
            </h2>
            {message && (
              <p className="mt-1.5 whitespace-pre-line text-sm leading-relaxed text-slate-300">
                {message}
              </p>
            )}
          </div>
        </div>
        <div className="mt-6 flex items-center justify-end gap-3">
          <button
            ref={cancelRef}
            type="button"
            onClick={onCancel}
            className="inline-flex items-center justify-center rounded-xl border border-white/15 bg-white/5 px-5 py-2.5 text-sm font-semibold text-slate-200 transition-colors hover:bg-white/10 hover:text-white focus:outline-none focus:ring-2 focus:ring-white/30"
          >
            {cancelText}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`${toneCfg.confirmBtn} !px-5 !py-2.5 !text-sm`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
